import * as React from "react";
import AppBar from "@mui/material/AppBar";
import Box from "@mui/material/Box";
import Toolbar from "@mui/material/Toolbar";
import dartslogo from "./dartslogo.png";
import MobFilter from "./mobFilter";
import { ThemeProvider, createTheme } from "@mui/material/styles";
import MobMenu from "./mobMenu";

export default function ButtonAppBar() {
  const darkTheme = createTheme({
    palette: {
      mode: "light",
      primary: {
        main: "#ffffff",
      },
    },
  });
  return (
    <Box sx={{ flexGrow: 1 }}>
      <ThemeProvider theme={darkTheme}>
        <AppBar position="static">
          <Toolbar
            sx={{
              display: "flex",
              alignItems: "right",
              justifyContent: "space-between",
            }}
          >
            <div>
              <img
                src={dartslogo}
                alt="Dartslogo"
                style={{ maxWidth: "60%", height: "auto" }}
              />
            </div>
            <MobFilter sx={{ flexGrow: 1 }} />
          </Toolbar>
        </AppBar>
      </ThemeProvider>
    </Box>
  );
}
